<template>
    <div>
        <div class="bg-white shadow-md rounded mx-auto px-3 md:px-4 py-4 w-mobile">
            <div v-if="activeWithdrawal" class="withdrawals-list">
                <h2 class="text-2xl mb-2">{{ $t('Open Withdrawal') }}</h2>
                <div class="open-withdrawals">
                    <div class="flex justify-between mb-4">
                        <div class="text-2xl text-red-600">
                            {{activeWithdrawal.amount | currency}}
                        </div>
                        <div class="text-sm line-height-2">
                            {{activeWithdrawal.created_at | datetime}}
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-center px-3 py-4 bg-green-500 rounded text-white">
                            {{ $t('Please show this code to cashier') }}
                            <div class="text-3xl tracking-wide font-weight-bold" dusk="withdrawal-pin">
                                {{activeWithdrawal.pin}}
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-start flex-wrap">
                        <button
                            class="px-4 py-2 bg-red-500 rounded-md font-semibold text-xs text-white uppercase hover:bg-red-600 active:bg-red-600 focus:outline-none transition ease-in-out duration-150"
                            @click="cancelWithdrawalRequest(activeWithdrawal.id)"
                            dusk="withdrawal-cancel"
                        >
                            <span>
                                {{ $t('Cancel withdrawal') }}
                            </span>
                        </button>
                        <div class="text-sm line-height-2">
                            &nbsp;{{ $t('and continue playing') }}
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="this.activeWithdrawal === null">
                <h2 class="text-2xl mb-1">{{ $t('New Withdrawal') }}</h2>
                <h4 class="text-lg mb-2">{{ $t('Balance') }}: {{ balance | currency }}</h4>
                <div>
                    <JetButton dusk="withdrawal-all" :processing="form.processing" class="mb-4" @click="withdraw">
                        {{ $t('Withdraw money') }} {{ balance | currency }}
                    </JetButton>
                </div>

                <form class="flex items-start mb-4" @submit.prevent="withdraw">
                    <div class="withdraw-custom pr-3">
                        <JetInput dusk="withdrawal-amount" id="withdrawAmount" v-model="form.withdrawAmount" :placeholder="$t('Custom Amount')" type="number" step="0.01" required/>
                        <JetInputError :message="errors.withdrawAmount" class="mt-2" />
                    </div>
                    <JetButton dusk="withdrawal-confirm" :processing="form.processing" class="rounded-r" type="submit">
                        {{ $t('Withdraw') }}
                    </JetButton>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'

export default {
    name: 'Withdrawal',
    props: {
        activeRequest: Object,
        balance: Number,
        errors: Object
    },
    components: { JetButton, JetInput, JetInputError },
    metaInfo() {
        return {
            title: this.title
        }
    },
    data() {
        return {
            polling: null,
            form: {
                withdrawAmount: '',
                processing: false,
            },
            activeWithdrawal: this.activeRequest,
        }
    },
    computed: {
        title () {
            return this.$t('Withdrawal');
        },
    },
    watch: {
        activeRequest: function (value) {
            this.activeWithdrawal = value;
        }
    },
    methods: {
        async withdraw() {
            this.form.processing = true;
            await this.$inertia.post(route('withdraw.request').url(), {
                withdrawAmount:  this.form.withdrawAmount ? this.form.withdrawAmount : this.balance
            });
            this.form.processing = false;
        },
        cancelWithdrawalRequest(id) {
            this.$inertia.post(route('withdraw.cancel').url(), {
                id: id
            })
        },
        getActiveRequest() {
            this.polling = setInterval(() => {
                axios.get(route('withdraw.get-active').url()).then(response => {
                    this.activeWithdrawal = response.data.activeRequest;
                });
            },5000);

            Echo
                .private(`player-${this.$page.props.user.id}`)
                .listen('WithdrawalConfirmed', () => {
                    this.$inertia.visit(this.route('casino.home'));
                });
        }
    },
    mounted() {
        console.log('mounted');
        this.getActiveRequest();
    },
    beforeDestroy() {
        clearInterval(this.polling);
    }
}
</script>

<style lang="scss">
.withdraw-custom {
    width: 60%;

    input {
        width: 100%;
        padding-top: 0.3rem;
        padding-bottom: 0.3rem;

        &::placeholder {
            font-size: 0.85rem;
        }
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }
}
.line-height-2 {
    line-height: 2rem;
}
</style>
